module.exports = __webpack_public_path__ + "static/img/043_TO8_1545.5cfb586.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/043_TO8_1545.jpg
// module id = xItA
// module chunks = 0